var _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBinGeneralWastePinPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 48,
    viewBox: "0 0 33 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6434 16.3217C32.6434 25.3359 16.3217 47.4813 16.3217 47.4813C16.3217 47.4813 0 25.3359 0 16.3217C0 7.30747 7.30747 0 16.3217 0C25.3359 0 32.6434 7.30747 32.6434 16.3217Z",
    fill: "#168D8B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11.5,
    fill: "#25A764",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6037 11.3207H18.7028V10.1604C18.7028 9.85262 18.5805 9.55747 18.3629 9.33986C18.1453 9.12225 17.8501 9 17.5424 9H14.0613C13.7535 9 13.4584 9.12225 13.2408 9.33986C13.0232 9.55747 12.9009 9.85262 12.9009 10.1604V11.3207H10V12.4811H11.1604V21.1839C11.1604 21.6455 11.3437 22.0882 11.6702 22.4146C11.9966 22.741 12.4393 22.9244 12.9009 22.9244H18.7028C19.1644 22.9244 19.6071 22.741 19.9335 22.4146C20.2599 22.0882 20.4433 21.6455 20.4433 21.1839V12.4811H21.6037V11.3207ZM14.0613 10.1604H17.5424V11.3207H14.0613V10.1604ZM19.2829 21.1839C19.2829 21.3377 19.2218 21.4853 19.113 21.5941C19.0042 21.7029 18.8566 21.764 18.7028 21.764H12.9009C12.747 21.764 12.5995 21.7029 12.4907 21.5941C12.3819 21.4853 12.3207 21.3377 12.3207 21.1839V12.4811H19.2829V21.1839Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2214 18.8628V15.3817C15.2214 15.0613 14.9616 14.8015 14.6412 14.8015C14.3208 14.8015 14.061 15.0613 14.061 15.3817V18.8628C14.061 19.1832 14.3208 19.443 14.6412 19.443C14.9616 19.443 15.2214 19.1832 15.2214 18.8628Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5422 18.8628V15.3817C17.5422 15.0613 17.2825 14.8015 16.962 14.8015C16.6416 14.8015 16.3818 15.0613 16.3818 15.3817V18.8628C16.3818 19.1832 16.6416 19.443 16.962 19.443C17.2825 19.443 17.5422 19.1832 17.5422 18.8628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinGeneralWastePinPrimary);
export default __webpack_public_path__ + "static/media/trash-bin-generalWaste-pin-primary.5c0248e924f710b8c9ae486811551397.svg";
export { ForwardRef as ReactComponent };